import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {PICKUP, DELIVERY} from '../modules/OrderSetting/orderSettingTypes';

function useIsFoodRequired(products) {
  const [isFoodRequired, setIsFoodRequired] = useState(false);
  const [minFoodPrice, setMinFoodPrice] = useState('$0.00');

  const {
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
  } = useSelector(state => state.orderSettingReducer);

  const {alcoholic_restriction} =
    interOrderType === PICKUP && interPickUpDetails
      ? interPickUpDetails
      : interOrderType === DELIVERY &&
        interDeliveryDetails &&
        interDeliveryDetails.deliveryBusiness
      ? interDeliveryDetails.deliveryBusiness
      : {
          alcoholic_restriction: {
            is_alcoholic_restriction_enabled: false,
            min_food_total: 0,
          },
        };

  useEffect(() => {
    const productsInCart = products
      ? products.map(product => product.flatProduct)
      : [];

    if (
      alcoholic_restriction && alcoholic_restriction.is_alcoholic_restriction_enabled &&
      productsInCart
    ) {
      const minFoodPrice = alcoholic_restriction.min_food_total;

      setMinFoodPrice(`$${minFoodPrice}`);

      const alchoholicProducts = productsInCart.filter(
        product => product.is_alcoholic === true
      );

      const nonAlcoholicProducts = productsInCart.filter(
        product => product.is_food === true && product.is_alcoholic === false
      );

      const nonAlcoholicProductsPrice =
        nonAlcoholicProducts.length > 0
          ? nonAlcoholicProducts
              .map(
                alcoholicProduct =>
                  alcoholicProduct.price * alcoholicProduct.quantity
              )
              .reduce((acc, value) => acc + value)
          : 0;

      if (alchoholicProducts.length > 0) {
        if (
          nonAlcoholicProductsPrice < minFoodPrice ||
          nonAlcoholicProducts.length === 0
        ) {
          setIsFoodRequired(true);
        } else {
          setIsFoodRequired(false);
        }
      } else {
        setIsFoodRequired(false);
      }
    } else {
      setIsFoodRequired(false);
    }
  }, [interOrderType, products]);

  return {isFoodRequired, minFoodPrice};
}

export default useIsFoodRequired;
